module.exports = __webpack_public_path__ + "img/iconfont.52ee1b98.svg";